export default __webpack_public_path__ + "static/Fifth_Position_banner_mobile-1bdce599fcbe2425101abdecff6d1516.jpg";